export const SET_COUNTRY = "SET_COUNTRY";
export const SET_DOC_TYPE_QUANTITY = "SET_DOC_TYPE_QUANTITY";
export const SET_DOC_FILES = "SET_DOC_FILES";
export const SET_TOKEN = "SET_TOKEN";
export const GET_CORDS = "GET_CORDS";
export const GET_USER_DATA = "GET_USER_DATA";
export const SET_INITIAL_ONBOARDING_STATE = "SET_INITIAL_ONBOARDING_STATE";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_COMMERCE_DATA = "SET_COMMERCE_DATA";
export const SET_PERSON_DATA = "SET_PERSON_DATA";
export const SET_LEGAL_ENTITY = "SET_LEGAL_ENTITY";
export const SET_STATUS = "SET_STATUS";
export const IS_MERCHANT_PROFILE = "IS_MERCHANT_PROFILE";
export const DESTROY_ALL_DATA = "DESTROY_ALL_DATA";
export const SET_AGENT_ID = "SET_AGENT_ID";
export const SET_EMAIL = "SET_EMAIL";
